import {
  Attribute,
  CartLine,
} from '@lambda/commons/apis/shopify/types/storefront';
import { CartLineWithRCareSpecs } from '@/components/cart/types';
import { CartItemAttribute, UpdateCartParams } from './use-cart';

export const isDeliverableItem = (title: string) =>
  !title.toLowerCase().includes('reebelocare') &&
  !title.toLowerCase().includes('gift card') &&
  !title.toLowerCase().includes('express shipping');

export const filterOutShippingDeliveryAttributes = (
  attributes: Array<CartItemAttribute>,
) =>
  attributes.filter(
    (attr) =>
      ![
        '_deliver_min',
        '_deliver_max',
        '_shipping_option',
        '_shipping_option_cost',
        '_dispatch_min',
        '_dispatch_max',
        '_cutoff_time',
        '_cutoff_timezone',
      ].includes(attr.key),
  ) as Array<CartItemAttribute>;

export const updateLineItemAttributes = ({
  lineItem,
  attributes,
  checkSubsidyAttribute = false,
}: {
  lineItem: CartLine;
  attributes: Map<string, string>;
  /**
   * when this is enabled, it will check
   * 1. if subsidy tag exists in lineItem attributes but not in attributes; if it is, it will be
   * excluded in the result because that means subsidy for the offer in the lineItem is already removed
   * 2. if subsidy tag exists in attributes but not in lineItem, then it will add the attributes
   * default value is false
   */
  checkSubsidyAttribute?: boolean;
}) => {
  const subsidyAttrKey = '_subsidy';

  const lineItemHasSubsidyAttribute = lineItem.attributes.find(
    (attr) => attr.key === subsidyAttrKey,
  );
  const updatedAttributes = lineItem.attributes
    .map((attribute) => {
      const { key } = attribute;

      if (key === subsidyAttrKey && checkSubsidyAttribute)
        if (!attributes.has(key)) return undefined;

      if (attributes.has(key)) {
        return {
          key,
          value: attributes.get(key) as string,
        };
      }

      return attribute;
    })
    .filter(Boolean) as Array<Attribute>;

  return checkSubsidyAttribute &&
    !lineItemHasSubsidyAttribute &&
    attributes.has(subsidyAttrKey)
    ? [
        ...updatedAttributes,
        {
          key: subsidyAttrKey,
          value: attributes.get(subsidyAttrKey) as string,
        },
      ]
    : updatedAttributes;
};

export const updateParentItemDeliveryAttributes = async ({
  parentItem,
  update,
  attributes,
}: {
  parentItem: CartLineWithRCareSpecs;
  update: (lines: UpdateCartParams, cartIdParam?: string) => Promise<void>;
  attributes: Map<string, string>;
}) => {
  attributes.set('_shipping_option', 'standard');
  attributes.set('_shipping_option_cost', '0');

  await update([
    {
      id: parentItem.id,
      quantity: parentItem.quantity,
      attributes: updateLineItemAttributes({
        lineItem: parentItem,
        attributes,
      }),
    },
  ]);
};
export const maxQuantityPerOrder: Record<string, number> = {
  'P-SKINNYTRIOSIM': 10,
  'P-SPARKQUICKPREPAID3IN1SIM': 10,
};
